import { FC } from 'react';
import s from './deliveryDetails.module.scss';
import { Input } from '@components/UIKit/Input/Input';
import { StateType } from '@components/Pages/PaymentsPages/Withdraw/Form/Form';
import { useTranslation } from '@hooks/useTranslation';
interface Props {
  formState: StateType;
  changeFromData: <T extends keyof StateType>(key: T, value: StateType[T]) => void;
}
export const DeliveryDetails: FC<Props> = ({
  formState,
  changeFromData
}) => {
  const {
    translate: tr
  } = useTranslation();
  const {
    country,
    holderName,
    bankName,
    accountNumber,
    iban,
    swiftCode
  } = formState;
  return <div className={s.deliveryDetails} data-sentry-component="DeliveryDetails" data-sentry-source-file="DeliveryDetails.tsx">
            <div className={s.deliveryDetails__column}>
                <Input label={tr({
        id: 'withdraw.page.country.input.title'
      })} name={'country'} value={country} placeholder={tr({
        id: 'withdraw.page.country.input.placeholder'
      })} onPrint={value => {
        changeFromData('country', value);
      }} data-sentry-element="Input" data-sentry-source-file="DeliveryDetails.tsx" />
                <Input label={tr({
        id: 'withdraw.page.account.holder.input.title'
      })} name={'holderName'} value={holderName} placeholder={tr({
        id: 'withdraw.page.account.holder.input.placeholder'
      })} onPrint={value => {
        changeFromData('holderName', value);
      }} data-sentry-element="Input" data-sentry-source-file="DeliveryDetails.tsx" />
                <Input label={tr({
        id: 'withdraw.page.bank.name.input.title'
      })} name={'bankName'} value={bankName} placeholder={tr({
        id: 'withdraw.page.bank.name.input.placeholder'
      })} onPrint={value => {
        changeFromData('bankName', value);
      }} data-sentry-element="Input" data-sentry-source-file="DeliveryDetails.tsx" />
            </div>
            <div className={s.deliveryDetails__column}>
                <Input label={tr({
        id: 'withdraw.page.account.number.input.title'
      })} name={'accountNumber'} value={accountNumber} placeholder={tr({
        id: 'withdraw.page.account.number.input.placeholder'
      })} onPrint={value => {
        changeFromData('accountNumber', value);
      }} data-sentry-element="Input" data-sentry-source-file="DeliveryDetails.tsx" />
                <Input label={tr({
        id: 'withdraw.page.iban.input.title'
      })} name={'iban'} value={iban} placeholder={tr({
        id: 'withdraw.page.iban.input.placeholder'
      })} onPrint={value => {
        changeFromData('iban', value);
      }} data-sentry-element="Input" data-sentry-source-file="DeliveryDetails.tsx" />
                <Input label={tr({
        id: 'withdraw.page.swift.input.title'
      })} name={'swiftCode'} value={swiftCode} placeholder={tr({
        id: 'withdraw.page.swift.input.placeholder'
      })} onPrint={value => {
        changeFromData('swiftCode', value);
      }} data-sentry-element="Input" data-sentry-source-file="DeliveryDetails.tsx" />
            </div>
        </div>;
};